<template>
  <div class="swiper-cont-box">
    <swiper :options="swiperOption" ref="mySwiper" class="mySwiper">            
      <!-- slides --> 
      <div class="swiper-pagination"  slot="pagination"></div>   

      <swiper-slide v-for="(item,index) in nowData" :key="index">
        <div class="item">
          <div class="h1"><span>Q{{index + 1}}：</span>{{problem[index].title}}？</div>
          <span class="hai"><img src="@/assets/hai.png" alt="" srcset=""></span>
          <div class="cont" v-for="(val,ind) in item.cont" :key="ind">
            <span class="head"><img :src="val.img2" @click="toDetail(val.id)" alt=""></span>
            <div class="content">
              <span :class="['thumbs',getActive(val,problem[index].id)?'active':'']" @click="tapzan(index,ind,problem[index].id)">{{val.thumbs}}</span>
              <span class="name">{{val.name}}</span>
              <span class="txt">{{val.job}}</span>
              <audioTemplate :music="val.music" :index="(index+1)+'_'+(ind+1)" @playMusic="playMusic"></audioTemplate>
            </div>
          </div>
        </div>
      </swiper-slide>          
  </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css' 
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import audioTemplate from "./audio"
import data from "@/assets/data.js"
import {AddThumbs,GetList} from "@/api.js"
// import audioTemplate from 'vue-aplayer'

export default {
  name: 'indexHome',
	components: {
    swiper,
    swiperSlide,
    audioTemplate
  },
  data () {
    const that = this;
    return {
      data,
      problem: [
        {
          id: 'b1',
          title: '为什么很多优秀的创业者都有斜杠倾向'
        },{
          id: 'b7',
          title: '初创公司怎样才能杀出重围，脱颖而出'
        },{
          id: 'b3',
          title: '斜杠的哪种特质会成为你进行项目投资或招聘员工的评判依据'
        },{
          id: 'b5',
          title: '拥有斜杠特质在你了解客户、服务客户过程中发挥哪些重要价值'
        },{
          id: 'b2',
          title: '斜杠越来越流行，是必然趋势还是偶然现象'
        },{
          id: 'b4',
          title: '年轻人创业是否可以选择从斜杠试水'
        },{
          id: 'b6',
          title: '斜杠特质是否让你在众多管理角色中穿梭自如'
        },
      ],
      nowData: [],

      imgIndex: 0,
      // swiper轮播的参数           
      swiperOption: { 
        //循环
        loop: false,
        autoHeight: true,
        //分页器设置
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "bullets",
          observer:true,
          observeParents:true,
          dynamicBullets: true,
          dynamicMainBullets: 5,
          bulletActiveClass: 'slide_dot_active',
          bulletClass: 'slide_dot',
          // 切换成数字模式
            renderBullet(index, className) {
              return `<span class="${className}">Q${index + 1}</span>`
            }
        } ,
        on: {
          //滑动之后回调函数
          slideChangeTransitionStart: function() {
            /* realIndex为滚动到当前的slide索引值 */
            that.imgIndex= this.realIndex;
          },
        },
      } 
    }
  },
	mounted () {
    this.getList()
	},
	methods: {
    toDetail(id){
      this.$router.push({name: 'redWoodDetail',params: { id: id}})
    },
    getActive(obj,problem_id) {
      let indexData = localStorage.getItem('all_data_s');

      let status = false;
      if(indexData){
        let data = JSON.parse(indexData)
        
        data.forEach((item,index) => {

          if(item.id == obj.id){
            item.problem.forEach((val,ind) => {
              if(val.id == problem_id){
                status = true;
              }
            })
          }
        })
      }
      return status || obj.fabulous;
    },
    getList(){

      let nowData = []
      this.problem.forEach((item,index) => {
        let json = {}
        json.title = item
        json.cont = []

        this.data.forEach((val,ind) => {
          

          val.problem.forEach((name,key) => {
            if(item.id == name.id){
              let cont_json = {}
              cont_json.id = val.id
              cont_json.name = val.name
              cont_json.job = val.job
              cont_json.img2 = val.img2

              cont_json.music = name.music
              cont_json.thumbs = name.thumbs
              cont_json.fabulous = name.fabulous
              json.cont.push(cont_json)
            }
          })
        })
        nowData.push(json)
      })
      this.nowData = nowData

      GetList({type_id: 2,size:10000}).then(res => {
        if(res.code == 0){
          let data = res.data

          data.forEach((item,index) => {
            if(item.content_id.length > 3){
              let arr = item.content_id.split('_')
              this.nowData.forEach((val,ind) => {
                if(val.title.id == arr[1]){
                  val.cont.forEach((name,key) => {
                    if(name.id == arr[0]){
                      name.thumbs = item.data
                    }
                  })
                }
              })
            }
          })

        }
      })
    },
    playMusic(e){
      let arr = e.toString().split('_')

      this.nowData.forEach((item,index) => {
        item.cont.forEach((val,ind) => {
          if(index == arr[0]-1){
            if(ind == arr[1]-1){
              val.music.speaking = true
            }
            else{
              val.music.speaking = false
            }
          }
          else{
            val.music.speaking = false
          }
        })
      })
    },
    hasID(data,id){

      for(var i=0;i<data.length;i++){
        if(data[i].id == id){
          return i
        }
      }
      return -1
    },
    tapzan(Aindex,Aind,problemID){

      let content_id = this.nowData[Aindex].cont[Aind].id +'_'+ problemID
      let addData = {
        type_id: 2,
        content_id: content_id
      }
      AddThumbs(addData).then(res => {
        if(res.code == 0){
          this.nowData[Aindex].cont[Aind].fabulous = true
          this.nowData[Aindex].cont[Aind].thumbs +=1


          let indexData = localStorage.getItem('all_data_s');
          let data = []
          if(indexData){
            data = JSON.parse(indexData)
          }

          let json = {}
          json.problem = []
          this.nowData.forEach((item,index) => {

            item.cont.forEach((name,key) => {
              if(name.fabulous){

                

                let a = {}
                a.id = this.problem[index].id
                a.fabulous = true

                let index_id = this.hasID(data,name.id)

                if(index_id != -1){

                  if(this.hasID(data[index_id].problem,a.id) == -1){
                    data[index_id].problem.push(a)
                  }
                  
                }
                else{
                  json.id = name.id
                  json.problem.push(a)
                  data.push(json)
                }
              }
            })
          })

          let str = JSON.stringify(data)

          localStorage.setItem('all_data_s',str)
          
        }
      })
    },
  },
}
</script>

<style lang="scss">

audio{
  width: 100%;
}
.swiper-cont-box{
  .swiper-slide{
    overflow: hidden;
  }
  // height: calc(100vh - 3.48rem);
  // overflow: auto;
  padding-bottom: .36rem;
  .mySwiper{
    padding-top: .9rem;
    .swiper-pagination {
      top: .2rem;
      display: flex;
      justify-content: space-around;
      height: 1rem;
      .slide_dot{
        width: .74rem;
        height: .74rem;
        line-height: .74rem;
        border-radius: 50%;
        color: #fff;
        font-size: .36rem;
        font-weight: bold;
        background: #5bb65d;
        box-shadow: 2px 2px 1px #009d27;
        margin-top: .1rem;
      }
      .slide_dot_active{
        background: linear-gradient(to right, #ff933d , #ff6021);
        box-shadow: 2px 2px 1px #ffe7d9;
      }
    }
  }
  
  .item{
    background: #fff;
    margin: .4rem .4rem 0;
    padding: .22rem .26rem .5rem;
    border-radius: 5px;
    box-shadow: 0px 0px 20px rgba(162,219,216,0.6);
    position: relative;
    .h1{
      // position: absolute;
      // top: .25rem;
      // left: -0.2rem;
      width: 5rem;
      margin-left: -0.1rem;
      line-height: .4rem;
      text-align: left;
      padding: .1rem .1rem .1rem .16rem;
      box-sizing: border-box;
      border-radius: .36rem 5px 5px .36rem;
      font-size: .28rem;
      font-weight: bold;
      color: #fd7400;
      // background: linear-gradient(to right, #ff933d , #ff6021);
      // box-shadow: 4px 4px 2px #ffe7d9;
      span{
        // padding-right: .2rem;
      }
    }
    .hai{
      position: absolute;
      top: .25rem;
      right: 0.1rem;
      width: 1.51rem;
      height: 1.24rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .cont{
      display: flex;
      position: relative;
      align-items: center;
      padding: .26rem 0 .3rem;
      border-bottom: 1px solid #ededed;
      &:last-child{
        border-bottom: none;
      }
      .head{
        display: block;
        width: 1.3rem;
        height: 1.3rem;
        overflow: hidden;
        border-radius: 50%;
        // border: .06rem solid #e0e0e0;
        margin-right: .2rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .content{
        color: #333;
        text-align: left;
        width: calc(100% - 1.52rem);
        .thumbs{
          position: absolute;
          right: 0;
          top: .36rem;
          background: url('./../assets/zan.png') no-repeat;
          background-size: .3rem;
          padding-left: .4rem;
          font-size: .22rem;
          color: #d9d9d9;
          &.active{
            color: #ff702a;
            background: url('./../assets/zaning.png') no-repeat;
            background-size: .3rem;
          }
        }
        
        .name{
          font-size: .28rem;
          font-weight: bold;
          display: block;
        }
        .txt{
          font-size: .22rem;
          line-height: .4rem;
          display: block;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/cont.vue